import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../../components/common/Spinner';
import Button from '../../components/common/Button';
import WarehousesTable from '../../components/blocks/WarehousesTable';
import AddWarehouseModal from '../../components/modals/AddWarehouseModal';
import { redirectToShopifySupplier, redirectToShipBob, redirectToAmazonMcf } from '../../store/actions/integrations';

import { getWarehouses, putWarehouse } from '../../store/actions/warehouses';
import { getProductsReplenishRetailers } from '../../store/actions/productsReplenish';

function WarehousesContainer(props) {
  const { data, isLoading, getWarehouses, putWarehouse, getProductsRetailers, supplierRetailers } = props;

  let [modalOpened, setModalOpened] = useState(false);

  const warehousesWithConnectedChannels = useMemo(() => {
    return data.map((warehouse) => {
      const connectedChannels = supplierRetailers
        .filter((supplierRetailer) => {
          return supplierRetailer.approved_warehouses?.length
            ? supplierRetailer.approved_warehouses.includes(warehouse.id)
            : true;
        })
        .map(({ id, name }) => ({ value: name, key: String(id) }));
      return { ...warehouse, connected_channels: connectedChannels };
    });
  }, [data, supplierRetailers]);

  useEffect(() => {
    getWarehouses();
    getProductsRetailers();
  }, [getWarehouses, getProductsRetailers]);

  const setIsEnabled = (warehouseId, isEnabled, priority) => {
    putWarehouse(warehouseId, { is_enabled: isEnabled, priority: priority });
  };

  const setPriority = (warehouseId, priority) => {
    putWarehouse(warehouseId, { priority: priority });
  };

  const addWarehouse = (provider, params) => {
    switch (provider) {
      case 'shopify':
        props.redirectToShopify(params);
        break;

      case 'shipbob':
        props.redirectToShipBob(params);
        break;

      case 'amazon_mcf':
        props.redirectToAmazonMcf();
        break;

      default:
        break;
    }

    setModalOpened(false);
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <WarehousesTable data={warehousesWithConnectedChannels} setPriority={setPriority} setIsEnabled={setIsEnabled} />
      <Button green text="Add Warehouse" onClick={() => setModalOpened(true)} />

      <AddWarehouseModal open={modalOpened} onClose={() => setModalOpened(false)} onContinue={addWarehouse} />
    </>
  );
}

const mapStateToProps = ({ warehouses, productsReplenish }) => {
  const { data, isLoading } = warehouses;
  const { retailers: supplierRetailers } = productsReplenish;

  return {
    data,
    isLoading,
    supplierRetailers,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getProductsRetailers: () => dispatch(getProductsReplenishRetailers()),
  getWarehouses: () => dispatch(getWarehouses()),
  putWarehouse: (warehouseId, data) => dispatch(putWarehouse(warehouseId, data)),
  redirectToShopify: (name) => dispatch(redirectToShopifySupplier(name)),
  redirectToAmazonMcf: () => dispatch(redirectToAmazonMcf()),
  redirectToShipBob: () => dispatch(redirectToShipBob()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarehousesContainer);

WarehousesContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getWarehouses: PropTypes.func.isRequired,
  putWarehouse: PropTypes.func.isRequired,
  redirectToShopify: PropTypes.func.isRequired,
};
